/**
 * Legacy Staff API
 *
 * DEPRECATED: Этот файл сохранен для обратной совместимости.
 * Используйте новые API сервисы из /api/services вместо этого:
 *
 * - dashboardApi: Dashboard статистика
 * - usersApi: Криейторы и партнеры
 * - accountsApi: OnlyFans аккаунты
 * - cplApi: CPL офферы и заказы
 * - financeApi: Финансы и выплаты
 */

// Import all services
import { dashboardApi } from './services/dashboardApi';
import { usersApi } from './services/usersApi';
import { accountsApi } from './services/accountsApi';
import { cplApi } from './services/cplApi';
import { financeApi } from './services/financeApi';

// Re-export all types
export * from './services/types';
export type { DashboardStats } from './services/dashboardApi';
export type {
  GetCreatorsParams,
  GetPartnersParams,
  GetBalanceHistoryParams,
  GetCreatorModelsParams,
  CreatorsResponse,
  PartnersResponse,
  BalanceHistoryResponse,
  CreatorModelsResponse,
} from './services/usersApi';
export type {
  GetOnlyFansAccountsParams,
  OnlyFansAccountsResponse,
  ModelHeaders,
  GetUniqueModelsByOfIdParams,
  UniqueModelByOfId,
  UniqueModelsByOfIdResponse,
} from './services/accountsApi';
export type {
  GetCPLOffersParams,
  GetCPLOrdersParams,
  GetCreatorCPLOrdersParams,
  GetPartnerCPLOffersParams,
  CPLOffersResponse,
  CPLOrdersResponse,
} from './services/cplApi';
export type {
  GetCommissionStatsParams,
  GetCommissionMonthStatsParams,
  GetWithdrawalRequestsParams,
  CommissionStatsResponse,
  CommissionMonthStatsResponse,
  WithdrawalRequestsResponse,
} from './services/financeApi';

// ============ Legacy Unified API ============
// Объединенный API для обратной совместимости

export const staffApi = {
  // Dashboard
  getDashboard: dashboardApi.getStats,

  // Creators
  getCreators: usersApi.getCreators,
  getCreator: usersApi.getCreator,
  updateCreator: usersApi.updateCreator,
  changeCreatorStatus: usersApi.changeCreatorStatus,
  changeCreatorBalance: usersApi.changeCreatorBalance,
  getCreatorBalance: usersApi.getCreatorBalance,
  getCreatorBalanceHistory: usersApi.getCreatorBalanceHistory,
  deleteCreator: usersApi.deleteCreator,
  getCreatorModels: usersApi.getCreatorModels,

  // Partners
  getPartners: usersApi.getPartners,
  getPartner: usersApi.getPartner,
  updatePartner: usersApi.updatePartner,
  changePartnerStatus: usersApi.changePartnerStatus,
  changePartnerBalance: usersApi.changePartnerBalance,
  getPartnerBalance: usersApi.getPartnerBalance,
  getPartnerBalanceHistory: usersApi.getPartnerBalanceHistory,
  deletePartner: usersApi.deletePartner,

  // OnlyFans Accounts
  getOnlyFansAccounts: accountsApi.getOnlyFansAccounts,
  getOnlyFansAccount: accountsApi.getOnlyFansAccount,
  updateOnlyFansAccount: accountsApi.updateOnlyFansAccount,
  updateOnlyFansAccountStatus: accountsApi.updateOnlyFansAccountStatus,
  activateOnlyFansAccount: accountsApi.activateOnlyFansAccount,
  deactivateOnlyFansAccount: accountsApi.deactivateOnlyFansAccount,
  verifyOnlyFansAccount: accountsApi.verifyOnlyFansAccount,
  getModelHeaders: accountsApi.getModelHeaders,
  addModelHeaders: accountsApi.addModelHeaders,
  updateModelHeaders: accountsApi.updateModelHeaders,

  // CPL
  getCPLOffers: cplApi.getCPLOffers,
  updateCPLOffer: cplApi.updateCPLOffer,
  approveCPLOffer: cplApi.approveCPLOffer,
  rejectCPLOffer: cplApi.rejectCPLOffer,
  getCPLOrders: cplApi.getCPLOrders,
  deactivateCPLOrder: cplApi.deactivateCPLOrder,
  getCreatorCPLOrders: cplApi.getCreatorCPLOrders,
  getPartnerCPLOffers: cplApi.getPartnerCPLOffers,

  // Finance
  getCommissionStatsByDays: financeApi.getCommissionStatsByDays,
  getCommissionStatsByMonth: financeApi.getCommissionStatsByMonth,
  getCPLCurrentMonthAmount: financeApi.getCPLCurrentMonthAmount,
  getRefShareCurrentMonthAmount: financeApi.getRefShareCurrentMonthAmount,
  getWithdrawalRequests: financeApi.getWithdrawalRequests,
  changeWithdrawalStatus: financeApi.changeWithdrawalStatus,

  // Legacy aliases (deprecated)
  getOffers: cplApi.getCPLOffers,
  updateOffer: cplApi.updateCPLOffer,
};

export default staffApi;
